'use client'

import { useEffect, useRef } from 'react'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useCatalogContext } from '@marketplace-web/catalog/catalog-page-data'
import { urlWithParams } from '@marketplace-web/browser/url-util'

import useFetchDynamicFilters from './useFetchDynamicFilters'
import useFilterReset from './useFilterReset'

const useHandleCatalogSearchTextChange = () => {
  const {
    state: {
      dynamicFilters: { selectedDynamicFilters },
      general: { filtersChangeCount },
    },
  } = useCatalogContext()
  const { searchParams } = useBrowserNavigation()

  const { resetFilters } = useFilterReset()

  const fetchDynamicFilters = useFetchDynamicFilters()

  const filtersChangeCountRef = useRef(filtersChangeCount)
  filtersChangeCountRef.current = filtersChangeCount

  const catalogIdRef = useRef(searchParams.catalog?.[0])
  catalogIdRef.current = searchParams.catalog?.[0]

  const selectedDynamicFiltersRef = useRef(selectedDynamicFilters)
  selectedDynamicFiltersRef.current = selectedDynamicFilters

  const searchText = searchParams.search_text ? String(searchParams.search_text) : undefined
  const searchByImageUuid = searchParams.search_by_image_uuid
    ? String(searchParams.search_by_image_uuid)
    : undefined

  const searchByImageUuidRef = useRef(searchByImageUuid)
  searchByImageUuidRef.current = searchByImageUuid

  const isInitialLoad = useRef(true)

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false

      return
    }

    if (filtersChangeCountRef.current < 1) return

    if (searchByImageUuidRef.current) {
      window.history.replaceState(
        null,
        '',
        urlWithParams(window.location.href, {
          search_by_image_uuid: '',
        }),
      )

      resetFilters()
    } else {
      fetchDynamicFilters({
        selectedDynamicFilters: selectedDynamicFiltersRef.current,
        isSearchTextOnly: true,
      })
    }
  }, [fetchDynamicFilters, searchText, resetFilters])
}

export default useHandleCatalogSearchTextChange
